
/* Fallback Quick Add content injector (safe) */
(function () {
  function getModalContainer() {
    var modal = document.querySelector('quick-add-modal[open], .quick-add-modal[open]');
    if (!modal) return null;
    return (
      modal.querySelector('[id^="QuickAddInfo-"]') ||
      modal.querySelector('.quick-add-modal__content') ||
      modal
    );
  }

  // When product-info finishes loading its HTML, ensure it's shown inside the modal
  document.addEventListener('product-info:loaded', function (ev) {
    var container = getModalContainer();
    if (!container) return;

    // If modal is empty, inject the loaded product-info element
    if (!container.querySelector('product-info')) {
      try {
        container.innerHTML = '';
        container.appendChild(ev.target);
      } catch (e) {
        // no-op
      }
    }
  });

  // As a hard fallback, when the modal opens, if still empty, try to copy any product-info in DOM
  document.addEventListener('click', function (ev) {
    var opener = ev.target.closest('[data-quick-add], [data-open-quick-add], .quick-add__submit');
    if (!opener) return;
    setTimeout(function () {
      var container = getModalContainer();
      if (!container) return;
      if (!container.innerHTML.trim()) {
        var pi = document.querySelector('product-info');
        if (pi) {
          try {
            container.innerHTML = '';
            container.appendChild(pi.cloneNode(true));
          } catch (e) {}
        }
      }
    }, 250);
  });
})();
